import { getYMALProductPrice } from './getYMALProductPrice';

import { normaliseCompositeSizeId } from '@/modules/filters/helpers';
import { type SimilarProduct } from '@/modules/similar/aliases';
import { getSizeNames } from '@/modules/similar/helpers/getSizeNames';

export function extractYMALFilterOptions(
  products: SimilarProduct[],
  sizeNameToIdsMap?: Map<string, string[]>
) {
  const sizes = new Set<string>();
  const colours = new Set<string>();
  const sizeAggregates: Record<string, number> = {};

  if (products.length === 0) {
    return {
      sizes: [],
      colours: [],
      priceRange: {
        min: 0,
        max: 0,
      },
      sizeAggregates: {},
    };
  }

  let minPrice = getYMALProductPrice(products[0].pricing);
  let maxPrice = minPrice;

  products.forEach((product) => {
    getSizeNames(product.sizes).forEach((size) => {
      sizes.add(size);

      if (sizeNameToIdsMap) {
        const compositeIds = sizeNameToIdsMap.get(size);
        if (compositeIds) {
          for (const compositeId of compositeIds) {
            // Normalize the composite ID to match pruning logic
            const normalized = normaliseCompositeSizeId(compositeId);
            sizeAggregates[normalized] = 1;
          }
        }
      }
    });

    const colourId = product.attributes?.colour?.[0];
    if (colourId) {
      colours.add(colourId);
    }

    const price = getYMALProductPrice(product.pricing);
    if (price < minPrice) {
      minPrice = price;
    }
    if (price > maxPrice) {
      maxPrice = price;
    }
  });

  return {
    sizes: Array.from(sizes),
    colours: Array.from(colours),
    priceRange: {
      min: minPrice,
      max: maxPrice,
    },
    sizeAggregates,
  };
}
